import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Site-wide top strip that only renders when the admin has toggled
 * settings.live_now_active === "true". Otherwise returns null so the
 * homepage doesn't waste space on a normal browsing day.
 */
export default function LiveBanner() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/settings")
      .then((r) => { if (alive) setSettings(r.data); })
      .catch(() => {});
    load();
    // Poll every 60s so shoppers see the banner light up mid-session.
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!settings || String(settings.live_now_active) !== "true") return null;

  const label = settings.live_now_label || "🔴 LIVE NOW — click to join";
  const url = settings.live_now_url || "https://whatnot.com";
  const secondary = settings.live_now_secondary || "";

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="live-now-banner"
      className="block bg-gradient-to-r from-[var(--cl-primary)] via-[#c02020] to-[var(--cl-primary)] text-white hover:brightness-110 transition-all"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-3 flex flex-wrap items-center justify-center gap-3 text-sm">
        <span className="pulse-dot" />
        <span className="font-semibold tracking-wide" data-testid="live-now-label">{label}</span>
        {secondary && <span className="text-white/85 hidden md:inline">· {secondary}</span>}
        <span className="text-xs uppercase tracking-widest opacity-80 ml-2">Open →</span>
      </div>
    </a>
  );
}
